import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Layout } from "@/components/Layout";
import { useAuthMe } from "./hooks/useLocalStorage";
import { useEffect } from "react";
import { BreadcrumbProvider } from "./components/BreadcrumbContext";
import { PartnerApplicant } from "./components/PartnerPage/PartnerApplicant";
import { ExchangeOffer } from "./components/PartnerPage/ExchangeOffer";
import ModifyValue from "./components/PartnerPage/ValueSetup/ModifyRuleValue";


function Router() {
  return (
    <BreadcrumbProvider>
      <Layout>
        <Switch>
          <Route path="/">
            <PartnerApplicant />
          </Route>
          <Route path="/exchangeoffers">
            <ExchangeOffer />
          </Route>
          <Route path="/createversion/:ruleId">
            <ModifyValue />
          </Route>
        </Switch>
      </Layout>
    </BreadcrumbProvider>
  );
}

function AuthGuard({ children }: { children: React.ReactNode }) {
  const { data, isLoading, isError } = useAuthMe();

  useEffect(() => {
    if (isError) {
      console.log("Authentication check failed");
    }
  }, [isError]);

  // if (isLoading) {
  //   return (
  //     <div className="flex items-center justify-center min-h-screen">
  //       <div className="text-center">
  //         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
  //         <p className="text-muted-foreground">redirecting...</p>
  //       </div>
  //     </div>
  //   );
  // }

  // if (isError || !data) {
  //   return <RedirectingScreen />;
  // }

  return <>{children}</>;
}

function App() {
  useAuthMe();
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <AuthGuard>
          <Router />
        </AuthGuard>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
